import { markRaw } from "vue";
import { fabric } from "fabric";

const verifyRef = (ref: HTMLCanvasElement | undefined): ref is HTMLCanvasElement => {
  return ref !== undefined;
};

export default (
  canvas: fabric.Canvas,
  ref: HTMLCanvasElement | undefined,
  canvasWidth: number,
  canvasHeight: number,
  color: string
): fabric.Canvas => {
  if (verifyRef(ref)) {
    canvas = markRaw(new fabric.Canvas(ref));

    canvas.setWidth(canvasWidth);
    canvas.setHeight(canvasHeight);
    canvas.setBackgroundColor(color, () => {});

    return canvas;
  } else {
    throw new Error("Error when mounting canvas, useMountCanvas");
  }
};
